import { PropsWithChildren } from "react"
import { BrowserRouter } from "react-router-dom"
import { AlertProvider, ModalProvider, ThemeProvider } from "matsuri-ui"
import { M2mAuthenticationProvider } from "m2m-components/storage/useM2mAuth"
import { ErrorBoundary } from "../ErrorBoundary"
import { AppInitializer } from "./AppInitializer"
import { BackgroundFetchContextProvider } from "@/hooks/useBackgroundFetch"
import { LanguageProvider } from "@/providers/LanguageProvider"
import { theme } from "@/theme"
import { AppDownloadBanner } from "@/components/AppDownloadBanner/AppDownloadBanner"
import { getStorageAdapter } from "@/utils/capacitorStorageAdapter"

export const AppProvider = ({ children }: PropsWithChildren) => {
    return (
        <ThemeProvider theme={theme}>
            <ErrorBoundary>
                <BrowserRouter>
                    <BackgroundFetchContextProvider>
                        <LanguageProvider>
                            <M2mAuthenticationProvider
                                storageAdapter={getStorageAdapter()}
                            >
                                <AppInitializer>
                                    <AlertProvider position="top-center">
                                        <ModalProvider>
                                            <AppDownloadBanner />
                                            {children}
                                        </ModalProvider>
                                    </AlertProvider>
                                </AppInitializer>
                            </M2mAuthenticationProvider>
                        </LanguageProvider>
                    </BackgroundFetchContextProvider>
                </BrowserRouter>
            </ErrorBoundary>
        </ThemeProvider>
    )
}
